export default __webpack_public_path__ + "static/media/remergr.2ab1b0f1.svg";